import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { IconRegistryService } from './services';
import { ICONS_BASE_URL } from './tokens';

export interface MyIconsConfig {
  baseUrl?: string;
}

export function provideIcons(config?: MyIconsConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    IconRegistryService,
    config?.baseUrl
      ? { provide: ICONS_BASE_URL, useValue: config.baseUrl }
      : [],
    provideAppInitializer(() => {
      const registry = inject(IconRegistryService);
      registry.registerIcons();
    }),
  ]);
}
